import * as v from "valibot";

const stripSpaces = (code: string) => code.replace(/\s/g, "");

/** A code from an authenticator app, as typed or pasted: spaces are dropped. */
export const totpCodeSchema = v.object({
  code: v.pipe(
    v.string(),
    v.transform(stripSpaces),
    v.regex(/^\d{6}$/, "Enter the 6-digit code from the app.")
  ),
});

/** Whether a field's value is a whole code yet, so the form can submit without a click. */
export const isCompleteTotpCode = (value: string) => /^\d{6}$/.test(stripSpaces(value));
